import { Stack } from '@mui/material';
import React from 'react';
import Heading from '../../../atoms/Heading';
import { SanitySideItem } from '../../../../@types';
import { useSanity } from '../../../../hooks/useSanity';
import StyledSkeleton from '../../../atoms/StyledSkeleton';
import CMSTopItem from './CMSTopItem';
import useLocalization from '../../../../hooks/useLocalization';

const CasinoOffer = () => {
  const { t } = useLocalization();
  const { data: cmsContent, isLoading } = useSanity<SanitySideItem>('CasinoPromotionalTopContent'); //TODO: create content images that navigates to casino
  return (
    <>
      <Heading>
        <Heading.Title>{t('casino')}</Heading.Title>
      </Heading>
      <Stack direction='row' spacing={2} sx={{ overflowX: 'auto', minHeight: '150px' }}>
        {isLoading && (
          <Stack
            sx={{
              p: 1,
              width: '100%',
            }}
          >
            {Array.from({ length: 4 }).map((_, index) => (
              <StyledSkeleton key={index} variant='rectangular' width='100%' height={'25vh'} sx={{ mb: 1 }} />
            ))}
          </Stack>
        )}
        {cmsContent?.map((item) => <CMSTopItem key={item.title} item={item} />)}
      </Stack>
    </>
  );
};

export default CasinoOffer;
